
// import React, { useState } from 'react';
// import { toast } from 'react-toastify';
// import { useNavigate, Link } from 'react-router-dom';  // <-- import Link
// import axios from 'axios';

// function Login() {
//   const [credentials, setCredentials] = useState({ username: '', password: '' });
//   const navigate = useNavigate();

//   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setCredentials({ ...credentials, [name]: value });
//   };
  
//   const login = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(`${baseUrl}/api/users/login`, credentials, { withCredentials: true });

//       if (response.status === 200 && response.data.success) {
//         const { user } = response.data;
//         const { tenantid, id: ownerid, username } = user;

//         localStorage.setItem('authToken', response.data.token || '');
//         localStorage.setItem('tenantid', tenantid);
//         localStorage.setItem('ownerid', ownerid);
//         localStorage.setItem('username', username);
//         localStorage.setItem('role', user.role || 'operator');
//         try {
//           localStorage.setItem('me', JSON.stringify({ id: user.id, tenantId: user.tenantid }));
//           window.__ME__ = { id: user.id, tenantId: user.tenantid };
//         } catch {}
//         if (user) {
//           localStorage.setItem('user', JSON.stringify(user));
//         }

//         navigate(`/${tenantid}/dashboard`);
//       } else {
//         toast.error(response.data.message || 'Unexpected error.');
//       }
//     } catch (error) {
//       if (error.response?.status === 401) {
//         toast.error('Invalid username or password.');
//       } else {
//         console.error('Login error:', error);
//         toast.error('Failed to login. Please try again.');
//       }
//     }
//   };

//   const handleOwner = () => navigate(`/ownerAdd`);

//   return (
//     <div className="col=md-4">
//       <div className="card">
//         <div className="card-body">
//           <h4 className="hdr hdr--primary hdr--lg">Login Here</h4>
//           <form onSubmit={login}>
//             <div className="form-group">
//               <label htmlFor="username">Username</label>
//               <input
//                 className="textInput"
//                 type="text"
//                 name="username"
//                 value={credentials.username}
//                 onChange={handleInputChange}
//                 placeholder="Enter your Username"
//                 required
//               />
//             </div>
//             <div className="form-group">
//               <label htmlFor="password">Password</label>
//               <input
//                 className="textInput"
//                 type="password"
//                 name="password"
//                 autoComplete="current-password"
//                 value={credentials.password}
//                 onChange={handleInputChange}
//                 placeholder="Enter your Password"
//                 required
//               />
//             </div>

//             {/* Forgot password link */}
//             <div className="mt-2">
//               {/* <Link to="/password-reset" className="text-sm text-blue-600 hover:underline"> */}
//               <Link to="/reset-password" className="text-sm text-blue-600 hover:underline">
//                 Forgot password?
//               </Link>
//             </div>

//             <button className="btn btn-primary" type="submit">Login</button>
//             <button onClick={handleOwner} className="btn btn-primary" type="button">Create Account</button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Login;



import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

function Login() {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };
  
  const login = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    try {
      const response = await axios.post(`${baseUrl}/api/users/login`, credentials, { 
        withCredentials: true 
      });

      if (response.status === 200 && response.data.success) {
        const { user, sessionId } = response.data;
        const { tenantid, id: ownerid, username } = user;

        // ✅ Store session information in localStorage
        localStorage.setItem('authToken', response.data.token || '');
        localStorage.setItem('sessionId', sessionId); // ⭐ New: Store session ID
        localStorage.setItem('tenantid', tenantid);
        localStorage.setItem('ownerid', ownerid);
        localStorage.setItem('username', username);
        localStorage.setItem('role', user.role || 'operator');
        
        // Store user object for easy access
        try {
          localStorage.setItem('me', JSON.stringify({ id: user.id, tenantId: user.tenantid }));
          window.__ME__ = { id: user.id, tenantId: user.tenantid };
        } catch {}
        
        if (user) {
          localStorage.setItem('user', JSON.stringify(user));
        }

        // toast.success('Login successful!');
        navigate(`/${tenantid}/dashboard`);
      } else {
        toast.error(response.data.message || 'Unexpected error.');
      }
    } catch (error) {
      // Handle specific error cases
      if (error.response?.status === 401) {
        toast.error('Invalid username or password.');
      } else if (error.response?.status === 403) {
        // ⭐ New: Handle user limit reached error
        const errorData = error.response.data;
        toast.error(
          errorData.message || 'Maximum concurrent users reached. Please try again later.',
          { autoClose: 8000 }
        );
        
        // Optionally show details
        if (errorData.details) {
          console.log('User limit details:', errorData.details);
        }
      } else {
        console.error('Login error:', error);
        toast.error('Failed to login. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleOwner = () => navigate(`/ownerAdd`);

  return (
    <div className="col=md-4">
      <div className="card">
        <div className="card-body">
          <h4 className="hdr hdr--primary hdr--lg">Login Here</h4>
          <form onSubmit={login}>
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                className="textInput"
                type="text"
                name="username"
                value={credentials.username}
                onChange={handleInputChange}
                placeholder="Enter your Username"
                required
                disabled={isLoading}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                className="textInput"
                type="password"
                name="password"
                autoComplete="current-password"
                value={credentials.password}
                onChange={handleInputChange}
                placeholder="Enter your Password"
                required
                disabled={isLoading}
              />
            </div>

            {/* Forgot password link */}
            <div className="mt-2">
              <Link to="/reset-password" className="text-sm text-blue-600 hover:underline">
                Forgot password?
              </Link>
            </div>

            <button 
              className="btn btn-primary" 
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? 'Logging in...' : 'Login'}
            </button>
            <button 
              onClick={handleOwner} 
              className="btn btn-primary" 
              type="button"
              disabled={isLoading}
            >
              Create Account
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;